/** @jsx jsx */

import { Fragment as _, memo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import HotSpot from './HotSpot';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from 'factories/block';
import EditableBtn from 'components/lib/EditableBtn';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import imagePlaceholder from 'assets/Long Rectangle.svg';
import shouldUpdate from 'services/shouldUpdate';
import HotSpotScorable from './HotSpotScorable';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';
import Audio from 'components/lib/Audio';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';

const Components = {
  Row,
  Column,
  Text: EditableText,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Image: ({ children, ...props }) => {
    //
    const mediaContext = useContext(MediaContext) as IMediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: imagePlaceholder || imgPlaceholders[1],
          maxHeight: 30,
        }}
      />
    );
  },
  Video,
  Media,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [hotspot, txt] = children;

    if (!includeAdditionalTextField) {
      return hotspot;
    }

    return (
      <_>
        {hotspot}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  HotSpotElement: ({ children, ...props }) => children,
  HotSpotIsolated: HotSpot,
  HotSpotScorable,
  Answer: () => null,
  Feedback,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Attempt: ({ children, ...props }) => children,
  Modal: () => null,
  ModalWithEditableBtn: () => null,
  Audio,
  SVG,
  Embed,
  PDF,
  OpenPDF: ({ children, ...props }) => {
    return (
      <div
        css={css({
          img: {
            maxHeight: 'none !important',
          },
        })}
      >
        <OpenPDF {...(props as any)}>{children}</OpenPDF>
      </div>
    );
  },
};

const HotSpotDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default HotSpotDisplay;
